

import React from 'react'
import PageAccessWrapper from '../Accessibility/Page/PageAccessWrapper'

const OverviewSingleMovieAccess = ({

}) => {
    return (
        <PageAccessWrapper>
            Movie
        </PageAccessWrapper>
    )
}

export default OverviewSingleMovieAccess